import React, { useEffect } from "react";
import Swal from 'sweetalert2';
import { RotatingLines } from "react-loader-spinner";
import Sidebar from "../Sidebar/sidebar";
import Header from "../Sidebar/header";
import { useState } from "react";
import { useRef } from "react";
import Select from "react-select";
import axios from "axios";
import Rupee from "../../assets/img/profiles/Rupee-Symbol-Black.svg";
import SapioLogo from "../../assets/img/profiles/sapio-logo.svg";
import { ArrowBack } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import {
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  Typography,
  Button,
  Toolbar,
  Grid,
  IconButton,
  FormGroup,
  Switch,
  FormControlLabel,
  Paper,
  TableHead,
  TableBody,
} from "@mui/material";
import styled from "@emotion/styled";
import { borderRadius } from "@mui/system";
import DownloadIcon from "@mui/icons-material/Download";
import { typeOf } from "react-summernote";
import PaySlipHappycom from "../Admin/AdminPayroll/ManaulPayroll/PaySlipHappycom";
import ViewPaySlip from "../Admin/AdminPayroll/ManaulPayroll/ViewPaySlip";
//import { yearlyPayslip } from "./payConst";

// const STableRow = styled(TableRow)({
//   color: "#000000",
//   background: "#FFFFFF",
//   fontSize:"13px"
// });
const STableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
  // hide last border
  "&:nth-of-type(even)": {
    backgroundColor: "#e6e6fa",
  },
}));

const STableCell = styled(TableCell)({
  borderBottomColor: "#000000",
  fontSize: "13px",
  color: "#808080",
});

const SNCTableCell = styled(TableCell)({
  borderColor: "#FFFFFF",
  fontSize: "13px",
  color: "#808080",
});

const SCTableCell = styled(TableCell)({
  borderBottomColor: "#000000",
  // background: "#a2d8fb",
  // color:"#808080"
});
const LATableCell = styled(TableCell)({
  textAlign: "right",
});

const SButton = styled(Button)({
  background: "#2DB8C5",
  borderRadius: "4px",
  textTransform: "none",
  boxShadow: "none",
  padding: "8px",
  ":hover": {
    background: "#2DB8C5",
    boxShadow: "none",
  },
});

const Payslip = () => {
  const [menu, setMenu] = useState(false);
  const [showPayslip, setShowPayslip] = useState(false);
  const [showSlip, setShowSlip] = useState([]);
  const [totalEr, setTotalEr] = useState(0);
  const [totalDe, setTotalDe] = useState(0);
  const [totalRe, setTotalRe] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [step, setStep] = useState(0);
  const [yearlyPayslip, setYearlyPayslip] = useState({});
  // *****************************New*******************
  const [payslipData, setPayslipData] = useState(null);

  const [showManual, setShowManual] = useState(false)

  // *********************************************

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const [months, setMonths] = useState(
    `${new Date().getFullYear()}-${new Date().getMonth() + 1 > 9
      ? new Date().getMonth() + 1
      : `0${new Date().getMonth() + 1}`
    }`
  );
  const [month1, setMonth1] = useState(parseInt(new Date().getMonth() + 1));
  const [month, setmonth] = useState("");
  const [year, setYear] = useState(parseInt(months.split("-")[0]));
  const [year1, setYear1] = useState("");
  const [newYear, setNewYear] = useState(parseInt(new Date().getFullYear()));
  const [year2, setYear2] = useState(null);
  const [viewPayslip, setViewPayslip] = useState({});
  const [manualYear, setManualYear] = useState({label:parseInt(new Date().getFullYear()), value:parseInt(new Date().getFullYear())});

  console.log(month1);
  console.log('year',manualYear);

  const inputRef = useRef(null);
  const inputRefOne = useRef(null);

  //const netEarning = payslipdata[step]?.monthData.map((v) => v.earning)
  //const netDeduction = payslipdata[step]?.monthData.map((v) => v.deduction)

  console.log(showSlip);
  // console.log(months.split("-")[1]);

  // const options = yearlyPayslip.map((v, index) => {
  //   return {
  //     value: index,
  //     label: v.year,
  //   };
  // });

  /*
  const printDocument = () => {
    html2canvas(inputRef.current).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF();
      //   {
      //   orientation: "landscape",
      // }
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      const pdfHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("download.pdf");
    });
  };
  */

  const printPage = useReactToPrint({
    content: () => inputRef.current,
    documentTitle: "downloadpayslip",
  });

  const printPageOne = useReactToPrint({
    content: () => inputRefOne.current,
    documentTitle: "downloadAnnualPayslip",
  });

  const newRef = useRef(null);
  const newprintPage = useReactToPrint({
    content: () => newRef.current,
    documentTitle: "downloadAnnualPayslip",
  });

  /* PaySlip Get Api */
  const handlePayslip = (month, year) => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/payslip/`, {
        params: {
          empl_id: sessionStorage.getItem("emp_id"),
          month: month,
          year: year,
          toggle: "s",
        },
      })
      .then((res) => {
        console.log(res.data, "Hello");
        setShowSlip(res.data);
        //setYearlyPayslip(res.data);
        const sum = res.data.earning.reduce((accumulator, object) => {
          return accumulator + object.total;
        }, 0);
        setTotalEr(sum);
        const sum1 = res.data.deduction.reduce((accumulator, object) => {
          return accumulator + object.total;
        }, 0);
        setTotalDe(sum1);
        const sum2 = res.data.reimbursment.reduce((accumulator, object) => {
          return accumulator + object.total;
        }, 0);
        setTotalRe(sum2);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // *****************New******************
  const mo = {
    "01": "JANUARY",
    "02": "FEBRUARY",
    "03": "MARCH",
    "04": "APRIL",
    "05": "MAY",
    "06": "JUNE",
    "07": "JULY",
    "08": "AUGUST",
    "09": "SEPTEMBER",
    10: "OCTOBER",
    11: "NOVEMBER",
    12: "DECEMBER",
  };
  const fetchPayslipData = async (month, year) => {
    try {
      // setLoading(true);
      Swal.fire({
        title: 'Loading Payslip',
        html: 'Please wait while we fetch your payslip data...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/pay_slip_new/?month=${month}&year=${year}&empid=${sessionStorage.getItem("emp_id")}`
      );

      if (response.data.status === "success") {
        Swal.close(); // Close loading alert on success
        setPayslipData(response.data);
      } else {
        // setError("Payslip not found");
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Payslip not found'
        });
      }
    } catch (err) {
      // setError(err.message);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.message || 'Failed to fetch payslip'
      });
    }
    // finally {
    //   setLoading(false);
    // }
  };

  // Complete numberToWords function
  const numberToWords = (num) => {
    if (isNaN(num)) return "Zero Rupees Only";
    num = parseFloat(num);
    if (num === 0) return "Zero Rupees Only";

    const singleDigits = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const doubleDigits = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tensMultiple = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const tensPower = ["Hundred", "Thousand", "Lakh", "Crore"];

    const convertLessThanOneThousand = (n) => {
      if (n === 0) return "";
      let str = "";

      // Handle hundreds place
      if (n > 99) {
        str += singleDigits[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }

      // Handle tens and ones place
      if (n > 0) {
        if (n < 20) {
          str += doubleDigits[n - 10] || singleDigits[n];
        } else {
          str += tensMultiple[Math.floor(n / 10)];
          if (n % 10 > 0) {
            str += " " + singleDigits[n % 10];
          }
        }
      }

      return str.trim();
    };

    let str = "";
    let tempNum = Math.floor(num);

    // Handle Crores
    if (tempNum >= 10000000) {
      const crores = Math.floor(tempNum / 10000000);
      str += convertLessThanOneThousand(crores) + " Crore ";
      tempNum %= 10000000;
    }

    // Handle Lakhs
    if (tempNum >= 100000) {
      const lakhs = Math.floor(tempNum / 100000);
      str += convertLessThanOneThousand(lakhs) + " Lakh ";
      tempNum %= 100000;
    }

    // Handle Thousands
    if (tempNum >= 1000) {
      const thousands = Math.floor(tempNum / 1000);
      str += convertLessThanOneThousand(thousands) + " Thousand ";
      tempNum %= 1000;
    }

    // Handle remaining hundreds, tens and ones
    if (tempNum > 0) {
      str += convertLessThanOneThousand(tempNum);
    }

    // Handle decimal part (paise)
    const decimal = Math.round((num % 1) * 100);
    let paiseStr = "";
    if (decimal > 0) {
      paiseStr = " and " + convertLessThanOneThousand(decimal) + " Paise";
    }

    return (str.trim() || "Zero") + " Rupees" + paiseStr + " Only";
  };
  // *****************New******************


  const handleYearlyPayslip = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/payslip/`, {
        params: {
          empl_id: sessionStorage.getItem("emp_id"),
          year: year,
          toggle: "n",
        },
      })
      .then((res) => {
        setYearlyPayslip({
          year: res.data.year,
          monthData: res.data.monthData.map((ele) => ({
            ...ele,
            month_int: parseInt(new Date(`${ele.Month}` + 1).getMonth() + 1),
            year:
              parseInt(new Date(`${ele.Month}` + 1).getMonth() + 1) > 3
                ? parseInt(res.data.year)
                : parseInt(res.data.year) + 1,
          })),
        });
        setYear2(parseInt(res.data.year));
        setViewPayslip({});
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log(yearlyPayslip);
  useEffect(() => {
    handleYearlyPayslip();
  }, [year]);

  const handlePays = (month, year) => {
    let y;
    let m;
    if (month === "April") {
      m = "4";
      y = year;
    } else if (month === "May") {
      m = "5";
      y = year;
    } else if (month === "June") {
      m = "6";
      y = year;
    } else if (month === "July") {
      m = "7";
      y = year;
    } else if (month === "August") {
      m = "8";
      y = year;
    } else if (month === "September") {
      m = "9";
      y = year;
    } else if (month === "October") {
      m = "10";
      y = year;
    } else if (month === "November") {
      m = "11";
      y = year;
    } else if (month === "December") {
      m = "12";
      y = year;
    } else if (month === "January") {
      m = "1";
      y = parseInt(year) + 1;
    } else if (month === "February") {
      m = "2";
      y = parseInt(year) + 1;
    } else if (month === "March") {
      m = "3";
      y = parseInt(year) + 1;
    }
    // handlePayslip(m, y);
    fetchPayslipData(m, y);

    setYear1(y);
  };

  let currentYear = new Date().getFullYear();
  let earliestYear = 2017;
  let option = [];

  while (currentYear >= earliestYear) {
    let op = { label: "", value: "" };
    op.label = currentYear + "-" + (currentYear + 1);
    op.value = currentYear;

    option.push(op);
    currentYear -= 1;
  }

const monthsOption = [
  { label: "January", value: '01' },
  { label: "February", value: '02' },
  { label: "March", value: '03' },
  { label: "April", value: '04' },
  { label: "May", value: '05' },
  { label: "June", value: '06' },
  { label: "July", value: '07' },
  { label: "August", value: '08' },
  { label: "September", value: '09' },
  { label: "October", value: '10' },
  { label: "November", value: '11' },
  { label: "December", value: '12' },
];

const currYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 30 }, (_, i) => ({
  label: currYear - i,
  value: currYear - i,
}));

  const manualInputRef = useRef()

  const manualpaylsipPrint = useReactToPrint({
    content: () => manualInputRef.current,
    documentTitle: "downloadpayslip",
  });


  const [userData, setUserData] = useState(null)
  const fetchManual = async (month, year) => {
    try {
      const response = await axios.get(
        `https://oz.middleware.prod.api.ozhrms.com/get-employee-payslip-data/`,
        {
          params: {
            employee_id: sessionStorage.getItem('emp_id'),
            month: month,
            year: year,
          },
        }
      );

      console.log("Payslip Data:", response.data);
       if(response?.data?.data?.length > 0){
         setUserData(response?.data?.data[0] ||  null)
          
       }
       Swal.fire({
         icon: "success",
         text: response?.data?.message || 'Payslip Fetched Successfully',
       })
      return response.data;
    } catch (error) {
      console.error("Error fetching payslip data:", error);
      throw error;
    }
  };


  console.log('manualYear', manualYear)

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />

      <Sidebar />
      <div className="page-wrapper">
        <Grid container>
          {!isLoading && (
            <>
              {!showPayslip && (
                <>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box sx={{ height: "100%", p: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignContent: "center",
                        }}
                      >
                        <div
                          className="content container-fluid"
                          style={{
                            marginTop: "15px",
                            padding: "8px",
                            paddingLeft: "22px",
                          }}
                        >
                          <div className="page-header">
                            <h3 className="page-title">Payslip</h3>
                          </div>
                        </div>
                        <FormGroup sx={{ mt: 4, width: '290px' }}>
                          <FormControlLabel sx={{ color: "#fff !important" }} control={<Switch value={showManual} sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#2DB8C5",   // Checked thumb color
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                              backgroundColor: "#2DB8C5", // Checked track color
                            },
                          }} onChange={(e, checked) => {setShowManual(checked)
                          setUserData(null)}} />} label="Manual Payslip" />
                        </FormGroup>
                        {!showManual &&
                        <Box sx={{ width: "120px", mt: 4, mr: 2 }}>
                          <SButton onClick={printPageOne}>
                            <Typography
                              variant="body2"
                              sx={{ color: "#FFFFFF" }}
                            >
                              Download
                            </Typography>
                          </SButton>
                        </Box>
                        }
                        <Box sx={{ width: "200px", mt: 4 }}>
                        {showManual ? <Select
                            //isClearable
                            // defaultValue={yearOptions[0]}
                            placeholder="Financial Year"
                            options={yearOptions}
                            // value={ }
                            value={
                              manualYear
                            }
                            onChange={(e) => setManualYear(e)}
                          /> :
                          <Select
                            //isClearable
                            defaultValue={option[0]}
                            placeholder="Financial Year"
                            options={option}
                            // value={ }
                            value={
                              year !== ""
                                ? option.filter((ele) => ele.value === year)
                                : null
                            }
                            onChange={(e) => setYear(e.value)}
                          />}
                            
                        </Box>
                      </Box>
                      {(showManual && !userData) &&
                        <>
                          <TableContainer
                            component={Paper}
                            sx={{
                              borderRadius: "10px",
                              width: "100%",
                              mt: 2,
                            }}
                          >
                            <Table>
                              <TableHead>

                                <STableRow>
                                  <TableCell  align="left"  style={{ borderBottomColor: "#000000" }}>
                                    <Typography variant="body2">
                                      <b>Payslip</b>

                                    </Typography>
                                  </TableCell>

                                  {monthsOption?.map((month) => {
                                    return (
                                      <SCTableCell align="right">
                                        <Typography
                                          variant="body2"
                                          textAlign="center"
                                        >
                                          {month?.label}
                                          <IconButton onClick={()=> fetchManual(month?.value, manualYear?.value)}>  <DownloadIcon fontSize="small" /></IconButton>
                                        </Typography>
                                      </SCTableCell>
                                    );
                                  })}
                                </STableRow>
                              </TableHead>

                            </Table>
                          </TableContainer>
                        </> }
                        {!showManual &&
                        <TableContainer
                          sx={{ borderRadius: "10px" }}
                          ref={inputRefOne}
                        >
                          {yearlyPayslip?.monthData?.length > 0 && (
                            <Table
                              size="small"
                              aria-label="a dense table"
                              sx={{ width: "100%", fontSize: 10 }}
                            >
                              <STableRow>
                                {/* <SCTableCell /> */}
                                <TableCell
                                  align="left"
                                  style={{ borderBottomColor: "#000000" }}
                                >
                                  <Typography variant="body2">
                                    <b>Payslip</b>
                                  </Typography>
                                </TableCell>

                                {yearlyPayslip?.monthData?.map((v) => {
                                  return (
                                    <SCTableCell align="right">
                                      <Typography
                                        variant="body2"
                                        textAlign="center"
                                      >
                                        <b>
                                          {`${v.Month.split("")
                                            .join("")[0]
                                            .toLocaleUpperCase()}` +
                                            "" +
                                            `${v.Month.split("")
                                              .join("")
                                              .substring(1)}`}
                                        </b>
                                        <br />

                                        {v.year < newYear &&
                                          v.Month !== "total" ? (
                                          <IconButton
                                            onClick={() => (
                                              setShowPayslip(true),
                                              handlePays(
                                                v.Month,
                                                yearlyPayslip.year
                                              ),
                                              setmonth(v.Month)
                                            )}
                                          >
                                            <DownloadIcon fontSize="small" />
                                          </IconButton>
                                        ) : (
                                          <>
                                            {v.month_int < month1 &&
                                              v.year === newYear && (
                                                <IconButton
                                                  onClick={() => (
                                                    setShowPayslip(true),
                                                    handlePays(
                                                      v.Month,
                                                      yearlyPayslip.year
                                                    ),
                                                    setmonth(v.Month)
                                                  )}
                                                >
                                                  <DownloadIcon fontSize="small" />
                                                </IconButton>
                                              )}
                                          </>
                                        )}
                                      </Typography>
                                    </SCTableCell>
                                  );
                                })}
                              </STableRow>

                              <STableRow style={{ background: "#b4c5d5" }}>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>Attendance</b>
                                  </Typography>
                                </TableCell>

                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell />
                              </STableRow>

                              {yearlyPayslip?.monthData
                                ?.map((v) => v.attendance)[0]
                                ?.map((ele, index) => {
                                  return (
                                    <STableRow>
                                      <TableCell style={{ fontWeight: "500" }}>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[0][index]?.component_name
                                        }
                                      </TableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[0][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[1][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[2][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[3][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[4][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[5][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[6][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[7][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[8][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[9][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[10][index]?.data
                                        }
                                        {console.log(index)}
                                      </LATableCell>

                                      <LATableCell>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[11][index]?.data
                                        }
                                      </LATableCell>

                                      <LATableCell style={{ fontWeight: "500" }}>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.attendance
                                          )[12][index]?.data
                                        }
                                      </LATableCell>
                                    </STableRow>
                                  );
                                })}

                              <STableRow style={{ background: "#b4c5d5" }}>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>
                                      Earnings(
                                      <img
                                        style={{ width: "10px", height: "10px" }}
                                        src={Rupee}
                                      />
                                      )
                                    </b>
                                  </Typography>
                                </TableCell>

                                {Array.from(Array(13).keys()).map((num) => {
                                  return <TableCell />;
                                })}
                              </STableRow>

                              {yearlyPayslip?.monthData
                                ?.map((v) => v.earning)[0]
                                ?.map((ele, index) => {
                                  return (
                                    <STableRow>
                                      <TableCell style={{ fontWeight: "500" }}>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.earning
                                          )[0][index]?.component_name
                                        }
                                      </TableCell>

                                      {Array.from(Array(13).keys()).map((num) => {
                                        return (
                                          <LATableCell>
                                            {
                                              yearlyPayslip?.monthData.map(
                                                (v) => v.earning
                                              )[num][index]?.total
                                            }
                                          </LATableCell>
                                        );
                                      })}
                                    </STableRow>
                                  );
                                })}

                              <STableRow style={{ background: "#a2d8fb" }}>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>Gross Salary</b>
                                  </Typography>
                                </TableCell>

                                {yearlyPayslip?.monthData?.map((v) => {
                                  return (
                                    <LATableCell>
                                      <Typography variant="body2">
                                        {v.total_gross}
                                      </Typography>
                                    </LATableCell>
                                  );
                                })}
                              </STableRow>

                              <STableRow style={{ background: "#b4c5d5" }}>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>
                                      Deductions (
                                      <img
                                        style={{ width: "10px", height: "10px" }}
                                        src={Rupee}
                                      />
                                      )
                                    </b>
                                  </Typography>
                                </TableCell>

                                {Array.from(Array(13).keys()).map((num) => {
                                  return <TableCell />;
                                })}
                              </STableRow>

                              {yearlyPayslip?.monthData
                                ?.map((v) => v.deduction)[0]
                                ?.map((ele, index) => {
                                  return (
                                    <STableRow>
                                      <TableCell style={{ fontWeight: "500" }}>
                                        {
                                          yearlyPayslip?.monthData.map(
                                            (v) => v.deduction
                                          )[0][index]?.component_name
                                        }
                                      </TableCell>

                                      {Array.from(Array(13).keys()).map((num) => {
                                        return (
                                          <LATableCell>
                                            {
                                              yearlyPayslip?.monthData.map(
                                                (v) => v.deduction
                                              )[num][index]?.total
                                            }
                                          </LATableCell>
                                        );
                                      })}
                                    </STableRow>
                                  );
                                })}

                              <STableRow style={{ background: "#a2d8fb" }}>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>
                                      Net Salary (
                                      <img
                                        style={{ width: "10px", height: "10px" }}
                                        src={Rupee}
                                      />
                                      )
                                    </b>
                                  </Typography>
                                </TableCell>

                                {yearlyPayslip?.monthData?.map((v) => {
                                  return (
                                    <LATableCell>
                                      <Typography variant="body2">
                                        <b>{v.total_net}</b>
                                      </Typography>
                                    </LATableCell>
                                  );
                                })}
                              </STableRow>
                            </Table>
                          )}
                        </TableContainer>
                      }
                    </Box>
                  </Grid>

                  {/* <Grid item lg={2} md={2} sm={12} xs={12}>
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    color: "#000000",
                    backgroundColor: "rgba(255, 255, 255, 0.20)",
                  }}
                >
                  <Toolbar />
                  <a>
                    <Box
                      sx={{
                        width: "90%",
                        background: "#FFFFFF",
                        ml: "auto",
                        mr: "auto",
                        mt: 2,
                        mb: 2,
                        p: 2,
                        borderRadius: "4px",
                        boxShadow: 1,
                        "&:hover": {
                          boxShadow: 6,
                        },
                      }}
                    >
                      <Typography variant="h6">Form 16</Typography>
                      <br />

                      <Typography variant="body2">
                        View/download your form 16.
                      </Typography>
                    </Box>
                  </a>
                </Box>
              </Grid> */}
                </>
              )}
            </>
          )}
          {isLoading && (
            <Box
              sx={{
                height: "100%",
                width: "100%",
                p: 1,
                alignItems: "center",
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <RotatingLines
                  strokeColor="#2e86c1"
                  strokeWidth="5"
                  animationDuration="0.50"
                  width="50"
                  marginRight="700"
                  visible={true}
                />
              </div>
            </Box>
          )}
          <br />
          {showPayslip && sessionStorage.getItem("coid") === "Sapi141335" && (
            <>
              <Grid item lg={9} md={9} sm={12} xs={12}>
                <Box sx={{ background: "#FFFFFF", borderRadius: "4px" }}>
                  <Box
                    ref={inputRef}
                    sx={{
                      textAlign: "left",
                      p: 1.5,
                      ml: "auto",
                      mr: "auto",
                    }}
                  >
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item lg={3} md={3} sm={3} xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            alignContent: "center",
                            textAlign: "center",
                            p: 1,
                          }}
                        >
                          <img
                            src={SapioLogo}
                            alt="Company Logo"
                            style={{
                              height: "auto",
                              marginBottom: "8px",
                              height: "50px",
                              width: "auto",
                              marginRight: "auto",
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            alignContent: "center",
                            textAlign: "center",
                            p: 1,
                          }}
                        >
                          <Typography variant="body2">
                            <b style={{ fontSize: "16px" }}>
                              {payslipData?.user_details?.company_name || 'Company Name'}
                            </b>
                            <br />
                            <b>
                              {payslipData?.user_details?.company_address || 'Company Address'}
                            </b>
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={3} md={3} sm={3} xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            alignContent: "center",
                            textAlign: "center",
                            p: 1,
                          }}
                        >
                          <img
                            src={sessionStorage.getItem("company_logo")}
                            alt="Company Logo"
                            style={{
                              height: "auto",
                              marginBottom: "8px",
                              height: "40px",
                              width: "auto",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <hr style={{ marginTop: "-10px" }} />
                    <Box sx={{ textAlign: "center", p: 1 }}>
                      <Typography variant="body2">
                        <b>
                          <u>
                            Payslip for the Month of {mo[month?.split("-")?.[1]]}-
                            {month?.split("-")?.[0]}
                          </u>
                        </b>
                      </Typography>
                    </Box>

                    <Box sx={{ width: "100%", p: 1, pt: 0 }}>
                      <TableContainer>
                        <Table
                          size="small"
                          aria-label="employee details"
                          sx={{ width: "100%", borderLeftColor: "red" }}
                        >
                          <STableRow sx={{ borderColor: "#FFFFFF" }}>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>Employee Name</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.employee_name || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>Bank Name</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.bank_name || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>Days in Month</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.total_working_days || '-'}
                              </Typography>
                            </SNCTableCell>
                          </STableRow>

                          <STableRow sx={{ borderColor: "#FFFFFF" }}>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>Department</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.department || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>A/C</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.ac_number || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>Paid Days</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.worked_days || '-'}
                              </Typography>
                            </SNCTableCell>
                          </STableRow>

                          <STableRow sx={{ borderColor: "#FFFFFF" }}>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>Designation</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.designation || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>PAN</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.pan || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>LOP Days</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.absent || '-'}
                              </Typography>
                            </SNCTableCell>
                          </STableRow>

                          <STableRow sx={{ borderColor: "#FFFFFF" }}>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1, borderColor: "#FFFFFF" }}>
                              <Typography variant="body2">
                                <b>Gender</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.gender || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                <b>UAN</b>
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                              <Typography variant="body2">
                                : {payslipData?.user_details?.uan || '-'}
                              </Typography>
                            </SNCTableCell>
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                            <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                          </STableRow>
                        </Table>
                      </TableContainer>
                    </Box>
                    <br />

                    <Box sx={{ height: "100%", p: 1 }}>
                      <TableContainer>
                        <Table
                          size="small"
                          aria-label="salary breakdown"
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          {/* Earnings Column */}
                          <Table
                            size="small"
                            aria-label="earnings"
                            sx={{
                              width: "50%",
                              border: "1px solid rgba(224, 224, 224, 1)",
                            }}
                          >
                            <STableRow>
                              <SCTableCell>
                                <Typography variant="body2">
                                  <b>Earnings</b>
                                </Typography>
                              </SCTableCell>
                              <SCTableCell align="right">
                                <Typography variant="body2">
                                  <b>Total</b>
                                </Typography>
                              </SCTableCell>
                            </STableRow>

                            {payslipData?.user_details?.earning
                              ?.filter((ele) => ele?.total !== 0)
                              ?.sort((a, b) => {
                                // Sort Basic to the top
                                if (a.component_name === "Basic") return -1;
                                if (b.component_name === "Basic") return 1;
                                return 0; // Keep other items in their original order
                              })
                              ?.map((ele, index) => (
                                <STableRow key={`earning-${index}`}>
                                  <TableCell>
                                    <Typography variant="body2">
                                      {ele?.component_name || '-'}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography variant="body2">
                                      {ele?.total?.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "INR",
                                        minimumFractionDigits: 2,
                                      })}
                                    </Typography>
                                  </TableCell>
                                </STableRow>
                              ))}
                          </Table>

                          {/* Deductions Column */}
                          <Table
                            size="small"
                            aria-label="deductions"
                            sx={{
                              width: "50%",
                              textTransform: "capitalize",
                            }}
                          >
                            <STableRow height="20px">
                              <SCTableCell>
                                <Typography variant="body2">
                                  <b>Deductions</b>
                                </Typography>
                              </SCTableCell>
                              <SCTableCell align="right">
                                <Typography variant="body2">
                                  <b>Total</b>
                                </Typography>
                              </SCTableCell>
                            </STableRow>

                            {payslipData?.user_details?.deduction?.map((ele, index) => (
                              <STableRow key={`deduction-${index}`}>
                                <TableCell>
                                  <Typography variant="body2">
                                    {ele?.component_name === "otherdeduction"
                                      ? "Other Deduction"
                                      : ele?.component_name || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {ele?.total?.toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "INR",
                                      minimumFractionDigits: 2,
                                    })}
                                  </Typography>
                                </TableCell>
                              </STableRow>
                            ))}
                          </Table>
                        </Table>

                        {/* Gross Salary and Total Deductions */}
                        <Table
                          size="small"
                          aria-label="totals"
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Table size="small" sx={{ width: "50%" }}>
                            <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Gross Salary</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {payslipData?.user_details?.gross_pay?.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "INR",
                                    minimumFractionDigits: 2,
                                  })}
                                </Typography>
                              </TableCell>
                            </STableRow>
                          </Table>

                          <Table size="small" sx={{ width: "50%" }}>
                            <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Total Deductions</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {payslipData?.user_details?.deduction?.reduce(
                                    (sum, item) => sum + (item?.total || 0),
                                    0
                                  )?.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "INR",
                                    minimumFractionDigits: 2,
                                  })}
                                </Typography>
                              </TableCell>
                            </STableRow>
                          </Table>
                        </Table>

                        {/* Reimbursement and Net Salary */}
                        <Table
                          size="small"
                          aria-label="net salary"
                          sx={{ width: "100%" }}
                        >
                          {payslipData?.user_details?.reimbursment?.map((ele, index) => (
                            <STableRow key={`reimbursement-${index}`}>
                              <TableCell>
                                <Typography variant="body2">
                                  {ele?.component_name || '-'}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2"></Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2"></Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {ele?.total?.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "INR",
                                    minimumFractionDigits: 2,
                                  })}
                                </Typography>
                              </TableCell>
                            </STableRow>
                          ))}

                          <STableRow>
                            <TableCell>
                              <Typography variant="body2">
                                <b>Gross Earnings</b>
                              </Typography>
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell align="right">
                              <Typography variant="body2">
                                {payslipData?.user_details?.gross_pay?.toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 2,
                                })}
                              </Typography>
                            </TableCell>
                          </STableRow>

                          <STableRow>
                            <TableCell>
                              <Typography variant="body2">
                                <b>Total Deductions</b>
                              </Typography>
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell align="right">
                              <Typography variant="body2">
                                {payslipData?.user_details?.deduction?.reduce(
                                  (sum, item) => sum + (item?.total || 0),
                                  0
                                )?.toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 2,
                                })}
                              </Typography>
                            </TableCell>
                          </STableRow>

                          <STableRow>
                            <TableCell>
                              <Typography variant="body2">
                                <b>Total Reimbursements</b>
                              </Typography>
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell align="right">
                              <Typography variant="body2">
                                {payslipData?.user_details?.reimbursment?.reduce(
                                  (sum, item) => sum + (item?.total || 0),
                                  0
                                )?.toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 2,
                                })}
                              </Typography>
                            </TableCell>
                          </STableRow>

                          <STableRow>
                            <TableCell>
                              <Typography variant="body2">
                                <b>Net Salary</b>
                              </Typography>
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell align="right">
                              <Typography variant="body2">
                                {payslipData?.user_details?.net_pay?.toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 2,
                                })}
                              </Typography>
                            </TableCell>
                          </STableRow>
                        </Table>

                        <div
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        >
                          <i>
                            <b style={{ textTransform: "capitalize" }}>
                              Total Net Payable{" "}
                              {payslipData?.user_details?.net_pay?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                                minimumFractionDigits: 2,
                              })}{" "}
                              ({numberToWords(payslipData?.user_details?.net_pay || 0)} )
                            </b>
                          </i>
                          <p>
                            **Total Net Payable = Gross Earnings - Total
                            Deductions + Total Reimbursements
                          </p>

                          <i>
                            <p>
                              **This is a computer generated Payslip,
                              doesn't require signature of the competent
                              Authority**
                            </p>
                          </i>
                        </div>
                        <br />
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    color: "#000000",
                    backgroundColor: "rgba(255, 255, 255, 0.20)",
                  }}
                >
                  <Toolbar />
                  <a>
                    <Box
                      sx={{
                        width: "90%",
                        background: "#FFFFFF",
                        ml: "auto",
                        mr: "auto",
                        mt: 2,
                        mb: 2,
                        p: 2,
                        borderRadius: "4px",
                        boxShadow: 1,
                        "&:hover": {
                          boxShadow: 6,
                        },
                      }}
                    >
                      <Typography variant="h6">Form 16</Typography>
                      <br />

                      <Typography variant="body2">
                        View/download your form 16.
                      </Typography>
                    </Box>
                  </a>
                </Box>
              </Grid>
            </>
          )}
          {showPayslip && sessionStorage.getItem("coid") !== "Sapi141335" && sessionStorage.getItem("coid") !== "LSD 174449" && (
            <>
              <Grid item lg={9} md={9} sm={12} xs={12}>
                <Box sx={{ width: "95%", m: 1, ml: 1.5 }}>
                  <div
                    className="content container-fluid"
                    style={{
                      marginTop: "23px",
                      padding: "8px",
                      paddingLeft: "18px",
                    }}
                  >
                    <div className="page-header">
                      <h3 className="page-title">Payslip</h3>
                    </div>
                  </div>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      ml: "auto",
                      mr: "auto",
                      p: 1,
                    }}
                  >
                    <div className="col-md-3">
                      <span>
                        <button
                          className="btn btn-success btn-block "
                          style={{
                            padding: "4px 4px",
                            fontSize: "15px",
                            background: "#2db8c50",
                            border: "none",
                            color: "white",
                            borderRadius: "20px",
                          }}
                          classname="edit-icon"
                          onClick={() => setShowPayslip(false)}
                        >
                          <ArrowBack />
                        </button>
                      </span>
                      {/* <input
                        type="month"
                        className="col-md-12"
                        style={{ height: "40px", borderRadius: "4px" }}
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                      /> */}
                    </div>

                    <SButton onClick={printPage}>
                      <Typography variant="body2" sx={{ color: "#FFFFFF" }}>
                        Download
                      </Typography>
                    </SButton>
                  </Box>

                  {/* *********************New************************* */}
                  <Box sx={{ background: "#FFFFFF", borderRadius: "4px" }}>
                    <Box
                      ref={inputRef}
                      sx={{
                        textAlign: "left",
                        p: 1.5,
                        ml: "auto",
                        mr: "auto",
                      }}
                    >
                      <Grid container sx={{ mb: 1 }}>
                        <Grid item lg={3} md={3} sm={3} xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignContent: "center",
                              textAlign: "center",
                              p: 1,
                            }}
                          >
                            <img
                              src={sessionStorage.getItem("company_logo")}
                              alt="Company Logo"
                              style={{
                                height: "auto",
                                marginBottom: "8px",
                                height: "40px",
                                width: "auto",
                                marginRight: "auto",
                              }}
                            />
                          </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignContent: "center",
                              textAlign: "center",
                              p: 1,
                            }}
                          >
                            <Typography variant="body2">
                              <b style={{ fontSize: "16px" }}>
                                {payslipData?.user_details?.company_name || 'Company Name'}
                              </b>
                              <br />
                              <b>
                                {payslipData?.user_details?.company_address || 'Company Address'}
                              </b>
                              <p>
                                CIN : {payslipData?.user_details?.company_cin || 'Company CIN'}
                              </p>
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item lg={3} md={3} sm={3} xs={3} />
                      </Grid>

                      <Box sx={{ textAlign: "center", p: 1 }}>
                        <Typography variant="body2">
                          <b>
                            <u>
                              PAYSLIP FOR THE MONTH OF {mo[month?.split("-")?.[1]]}-
                              {month?.split("-")?.[0]}
                            </u>
                          </b>
                        </Typography>
                      </Box>

                      {/* Employee Details Table */}
                      <Box sx={{ width: "100%", p: 1, pt: 0 }}>
                        <TableContainer>
                          <Table
                            size="small"
                            aria-label="employee details"
                            sx={{ width: "100%", borderLeftColor: "red" }}
                          >
                            {/* ... (Employee details rows remain exactly the same as in your reference) ... */}
                            <STableRow sx={{ borderColor: "#FFFFFF" }}>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Employee ID</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.employee_id || "-"}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Bank Name:</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.bank_name}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>PAN</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.pan}
                                </Typography>
                              </SNCTableCell>
                            </STableRow>

                            <STableRow sx={{ borderColor: "#FFFFFF" }}>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Employee Name</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.employee_name}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>A/C</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.ac_number}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>LOP days</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.absent || "-"}
                                </Typography>
                              </SNCTableCell>
                            </STableRow>

                            <STableRow sx={{ borderColor: "#FFFFFF" }}>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Department</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.department}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>UAN</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.uan || 'N/A'}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>ESI</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.esi || 'N/A'}
                                </Typography>
                              </SNCTableCell>
                            </STableRow>

                            <STableRow sx={{ borderColor: "#FFFFFF" }}>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Designation</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.designation || "-"}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Days in month</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.total_working_days}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                            </STableRow>

                            <STableRow sx={{ borderColor: "#FFFFFF" }}>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1, borderColor: "#FFFFFF" }}>
                                <Typography variant="body2">
                                  <b>Gender</b>
                                </Typography>
                              </SNCTableCell>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.gender || "-"}
                                </Typography>
                              </SNCTableCell>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  <b>Paid days</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2">
                                  {payslipData?.user_details?.worked_days || "-"}
                                </Typography>
                              </SNCTableCell>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                            </STableRow>
                          </Table>
                        </TableContainer>
                      </Box>
                      <br />

                      {/* Earnings and Deductions Section */}
                      <Box sx={{ height: "100%", p: 1 }}>
                        <TableContainer>
                          {/* Earnings and Deductions in two columns */}
                          <Table
                            size="small"
                            aria-label="salary breakdown"
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            {/* Earnings Column */}
                            <Table
                              size="small"
                              aria-label="earnings"
                              sx={{
                                width: "50%",
                                border: "1px solid rgba(224, 224, 224, 1)",
                              }}
                            >
                              <STableRow>
                                <SCTableCell>
                                  <Typography variant="body2">
                                    <b>Particular</b>
                                  </Typography>
                                </SCTableCell>
                                <SCTableCell align="right">
                                  <Typography variant="body2">
                                    <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </SCTableCell>
                              </STableRow>

                              {payslipData?.user_details?.earning
                                ?.sort((a, b) => {
                                  // Sort Basic to the top
                                  if (a.component_name === "Basic") return -1;
                                  if (b.component_name === "Basic") return 1;
                                  return 0; // Keep other items in their original order
                                })
                                ?.map((ele, index) => (
                                  <STableRow key={`earning-${index}`}>
                                    <TableCell>
                                      <Typography variant="body2">
                                        {ele?.component_name || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <Typography variant="body2">
                                        {ele?.total?.toFixed(0) || '0'}
                                      </Typography>
                                    </TableCell>
                                  </STableRow>
                                ))}
                            </Table>

                            {/* Deductions Column */}
                            <Table
                              size="small"
                              aria-label="deductions"
                              sx={{ width: "50%" }}
                            >
                              <STableRow height="20px">
                                <SCTableCell>
                                  <Typography variant="body2">
                                    <b>Deduction</b>
                                  </Typography>
                                </SCTableCell>
                                <SCTableCell align="right">
                                  <Typography variant="body2">
                                    <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </SCTableCell>
                              </STableRow>

                              {payslipData?.user_details?.deduction?.map((ele, index) => (
                                <STableRow key={`deduction-${index}`}>
                                  <TableCell>
                                    <Typography variant="body2">
                                      {ele?.component_name || "-"}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography variant="body2">
                                      {ele?.total?.toFixed(0) || "0"}
                                    </Typography>
                                  </TableCell>
                                </STableRow>
                              ))}
                            </Table>
                          </Table>

                          {/* Gross Salary and Total Deductions */}
                          <Table
                            size="small"
                            aria-label="totals"
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Table size="small" sx={{ width: "50%" }}>
                              <STableRow>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>Gross Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {/* {payslipData?.user_details?.gross_pay?.toFixed(0) || "0"}
                                     */}
                                    {Number(payslipData?.user_details?.gross_pay || 0).toFixed(2)}                                  </Typography>
                                </TableCell>
                              </STableRow>
                            </Table>

                            <Table size="small" sx={{ width: "50%" }}>
                              <STableRow>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>Total Deductions (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {payslipData?.user_details?.deduction?.reduce(
                                      (sum, item) => sum + (item?.total || 0),
                                      0
                                    )?.toFixed(0) || "0"}
                                  </Typography>
                                </TableCell>
                              </STableRow>
                            </Table>
                          </Table>

                          {/* Reimbursement Section */}
                          <Table
                            size="small"
                            aria-label="reimbursement"
                            sx={{ width: "100%" }}
                          >
                            <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Reimbursement</b>
                                </Typography>
                              </TableCell>
                              <TableCell />
                              <TableCell />
                              <TableCell />
                            </STableRow>

                            {payslipData?.user_details?.reimbursment?.map((ele, index) => (
                              <STableRow key={`reimbursement-${index}`}>
                                <TableCell>
                                  <Typography variant="body2">
                                    {ele?.component_name || "-"}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2"></Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2"></Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {ele?.total?.toFixed(0) || "0"}
                                  </Typography>
                                </TableCell>
                              </STableRow>
                            ))}

                            <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Total Reimbursement (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                </Typography>
                              </TableCell>
                              <TableCell />
                              <TableCell />
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {payslipData?.user_details?.reimbursment?.reduce(
                                    (sum, item) => sum + (item?.total || 0),
                                    0
                                  )?.toFixed(0) || "0"}
                                </Typography>
                              </TableCell>
                            </STableRow>

                            {/* Net Salary */}
                            <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Net Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                </Typography>
                              </TableCell>
                              <TableCell />
                              <TableCell />
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {/* {Math.round(payslipData?.user_details?.net_pay) || "0"} */}
                                  {(payslipData?.user_details?.net_pay?.toFixed(2)) || "0.00"}
                                </Typography>
                              </TableCell>
                            </STableRow>
                          </Table>

                          {/* Footer */}
                          <div style={{ textAlign: "center" }}>
                            <i>
                              <b>
                                Total Net Payable ₹
                                {Math.round(payslipData?.user_details?.net_pay) || "0"} (
                                {numberToWords(payslipData?.user_details?.net_pay || 0)})
                              </b>
                            </i>
                            <p>
                              **Total Net Payable = Gross Earnings - Total
                              Deductions + Total Reimbursements
                            </p>

                            <i>
                              <p>
                                **This is a computer generated Payslip, doesn't
                                require signature of the competent Authority**
                              </p>
                            </i>
                          </div>
                          <br />
                        </TableContainer>
                      </Box>
                    </Box>
                  </Box>
                  {/* *******************New******************** */}

                </Box>
              </Grid>

              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    color: "#000000",
                    backgroundColor: "rgba(255, 255, 255, 0.20)",
                  }}
                >
                  <Toolbar />
                  <a>
                    <Box
                      sx={{
                        width: "90%",
                        background: "#FFFFFF",
                        ml: "auto",
                        mr: "auto",
                        mt: 2,
                        mb: 2,
                        p: 2,
                        borderRadius: "4px",
                        boxShadow: 1,
                        "&:hover": {
                          boxShadow: 6,
                        },
                      }}
                    >
                      <Typography variant="h6">Form 16</Typography>
                      <br />

                      <Typography variant="body2">
                        View/download your form 16.
                      </Typography>
                    </Box>
                  </a>
                </Box>
              </Grid>
            </>
          )}



          {showPayslip && sessionStorage.getItem("coid") === "LSD 174449" && (
            <>
              <Grid item lg={9} md={9} sm={12} xs={12}>
                <Box sx={{ width: "95%", m: 1, ml: 1.5 }}>
                  <div
                    className="content container-fluid"
                    style={{
                      marginTop: "23px",
                      padding: "8px",
                      paddingLeft: "18px",
                    }}
                  >
                    <div className="page-header">
                      <h3 className="page-title">Payslip</h3>
                    </div>
                  </div>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      ml: "auto",
                      mr: "auto",
                      p: 1,
                    }}
                  >
                    <div className="col-md-3">
                      <span>
                        <button
                          className="btn btn-success btn-block "
                          style={{
                            padding: "4px 4px",
                            fontSize: "15px",
                            background: "#2db8c50",
                            border: "none",
                            color: "white",
                            borderRadius: "20px",
                          }}
                          classname="edit-icon"
                          onClick={() => setShowPayslip(false)}
                        >
                          <ArrowBack />
                        </button>
                      </span>
                      {/* <input
                        type="month"
                        className="col-md-12"
                        style={{ height: "40px", borderRadius: "4px" }}
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                      /> */}
                    </div>

                    <SButton onClick={newprintPage}>
                      <Typography variant="body2" sx={{ color: "#FFFFFF" }}>
                        Download
                      </Typography>
                    </SButton>
                  </Box>

                  {/* *********************New************************* */}
                  <Box sx={{ background: "#FFFFFF", borderRadius: "4px" }}>
                    <Box
                      ref={newRef}
                      sx={{
                        textAlign: "left",
                        // p: 1.5,
                        // ml: "auto",
                        // mr: "auto",
                      }}
                    >
                      <Box sx={{ minHeight: '70px', background: '#fff0cc', display: 'flex', alignItems: 'end', width: '100%', justifyContent: 'center', borderBottom: '1px solid', position: 'relative' }}>
                        <Typography variant="body2">
                          <b style={{ fontSize: "16px" }}>
                            {payslipData?.user_details?.company_name || 'Company Name'}
                          </b>
                          <br />

                          <img
                            src={sessionStorage.getItem("company_logo")}
                            alt="Company Logo"
                            style={{
                              height: "auto",
                              marginBottom: "8px",
                              height: "40px",
                              width: "auto",
                              marginLeft: "auto",
                              marginRight: "auto", position: 'absolute', top: 10, right: 10
                            }}
                          />
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: "center", width: '100%', p: '8px', borderBottom: '1px solid black' }}>
                        <Typography variant="body2">
                          <b style={{ fontSize: "16px" }}>
                            CIN : {payslipData?.user_details?.company_cin || 'Company CIN'}
                          </b>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', p: '8px', borderBottom: '3px solid black' }}>
                        <b>
                          {payslipData?.user_details?.company_address || 'Company Address'}
                        </b>
                      </Box>


                      <Box sx={{ textAlign: "center", width: '100%', p: '8px', background: '#ddebf7', borderBottom: '1px solid black' }}>
                        <Typography variant="body2">
                          <b style={{ fontSize: "16px" }}>

                            Payslip for the Month of {mo[month?.split("-")?.[1]]}- {month?.split("-")?.[0]}

                          </b>
                        </Typography>
                      </Box>

                      <Box sx={{ textAlign: "center", width: '100%', height: '35px' }} />

                      {/* Employee Details Table */}
                      <Box sx={{ width: "100%" }}>
                        <TableContainer>
                          <Table
                            size="small"
                            aria-label="employee details"
                            sx={{
                              width: "100%", border: "1px solid black",
                              borderCollapse: "collapse", "& td, & th": { border: "1px solid black" },
                            }}
                          >
                            {/* ... (Employee details rows remain exactly the same as in your reference) ... */}
                            <STableRow >
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Employee ID</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.employee_id || "-"}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Bank Name:</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.bank_name}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>PAN</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.pan}
                                </Typography>
                              </SNCTableCell>
                            </STableRow>

                            <STableRow >
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Employee Name</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.employee_name}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>A/C</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.ac_number}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>LOP days</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.absent || "-"}
                                </Typography>
                              </SNCTableCell>
                            </STableRow>

                            <STableRow >
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Department</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.department}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>UAN</b>
                                </Typography> */}
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.uan || 'N/A'}
                                </Typography> */}
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>ESI</b>
                                </Typography> */}
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.esi || 'N/A'}
                                </Typography> */}
                              </SNCTableCell>
                            </STableRow>

                            <STableRow >
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Designation</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.designation || "-"}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Days in month</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.total_working_days}
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                            </STableRow>

                            <STableRow >
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1, borderColor: "#FFFFFF" }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Gender</b>
                                </Typography>
                              </SNCTableCell>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.gender || "-"}
                                </Typography>
                              </SNCTableCell>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  <b>Paid days</b>
                                </Typography>
                              </SNCTableCell>

                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                  {payslipData?.user_details?.worked_days || "-"}
                                </Typography>
                              </SNCTableCell>
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                              <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                            </STableRow>
                          </Table>
                        </TableContainer>
                      </Box>
                      <br />

                      {/* Earnings and Deductions Section */}
                      <Box sx={{ height: "100%" }}>
                        <TableContainer>
                          {/* Earnings and Deductions in two columns */}
                          <Table
                            size="small"
                            aria-label="salary breakdown"
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            {/* Earnings Column */}
                            <Table
                              size="small"
                              aria-label="earnings"
                              sx={{
                                width: "50%",
                                // border: "1px solid rgba(224, 224, 224, 1)",
                                borderCollapse: "collapse", "& td, & th": { border: "1px solid black" },
                              }}
                            >
                              <STableRow>
                                <SCTableCell>
                                  <Typography variant="body2">
                                    <b>Particular</b>
                                  </Typography>
                                </SCTableCell>
                                <SCTableCell align="right">
                                  <Typography variant="body2">
                                    <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </SCTableCell>
                              </STableRow>

                              {payslipData?.user_details?.earning
                                ?.sort((a, b) => {
                                  const priority = {
                                    Basic: 1,
                                    HRA: 2,
                                    "Conveyance Allowance": 3,
                                    "Medical Allowance": 4,
                                    "Special Allowance": 5
                                  };

                                  const getPriority = (name) => priority[name] || 999; // Others go last

                                  return getPriority(a.component_name) - getPriority(b.component_name);
                                })
                                ?.map((ele, index) => (
                                  <STableRow key={`earning-${index}`}>
                                    <TableCell>
                                      <Typography variant="body2">
                                        {ele?.component_name || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <Typography variant="body2">
                                        {ele?.total?.toFixed(0) || '0'}
                                      </Typography>
                                    </TableCell>
                                  </STableRow>
                                ))}
                            </Table>

                            {/* Deductions Column */}
                            <Table
                              size="small"
                              aria-label="deductions"
                              sx={{ width: "50%" }}
                            >
                              <STableRow height="20px">
                                <SCTableCell>
                                  <Typography variant="body2">
                                    <b>Deduction</b>
                                  </Typography>
                                </SCTableCell>
                                <SCTableCell align="right">
                                  <Typography variant="body2">
                                    <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </SCTableCell>
                              </STableRow>

                              {payslipData?.user_details?.deduction?.map((ele, index) => (
                                <STableRow key={`deduction-${index}`}>
                                  <TableCell>
                                    <Typography variant="body2">
                                      {ele?.component_name || "-"}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography variant="body2">
                                      {ele?.total?.toFixed(0) || "0"}
                                    </Typography>
                                  </TableCell>
                                </STableRow>
                              ))}
                              {Array.from({
                                length: Math.max(
                                  0,
                                  (payslipData?.user_details?.earning?.length || 0) -
                                  (payslipData?.user_details?.deduction?.length || 0)
                                ),
                              }).map((_, index) => (
                                <STableRow key={`deduction-spacer-${index}`} style={{ borderBottom: '0px' }}>
                                  <TableCell>
                                    <Typography variant="body2">&nbsp;</Typography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography variant="body2">&nbsp;</Typography>
                                  </TableCell>
                                </STableRow>
                              ))}
                            </Table>
                          </Table>

                          {/* Gross Salary and Total Deductions */}
                          <Table
                            size="small"
                            aria-label="totals"
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Table size="small" sx={{ width: "50%" }}>
                              <STableRow>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>Gross Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {/* {payslipData?.user_details?.gross_pay?.toFixed(0) || "0"}
                                     */}
                                    {Number(payslipData?.user_details?.gross_pay || 0).toFixed(2)}                                  </Typography>
                                </TableCell>
                              </STableRow>
                            </Table>

                            <Table size="small" sx={{ width: "50%" }}>
                              <STableRow>
                                <TableCell>
                                  <Typography variant="body2">
                                    <b>Total Deductions (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {payslipData?.user_details?.deduction?.reduce(
                                      (sum, item) => sum + (item?.total || 0),
                                      0
                                    )?.toFixed(0) || "0"}
                                  </Typography>
                                </TableCell>
                              </STableRow>
                            </Table>
                          </Table>

                          {/* Reimbursement Section */}
                          <Table
                            size="small"
                            aria-label="reimbursement"
                            sx={{ width: "100%" }}
                          >
                            {/* <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Reimbursement</b>
                                </Typography>
                              </TableCell>
                              <TableCell />
                              <TableCell />
                              <TableCell />
                            </STableRow>

                            {payslipData?.user_details?.reimbursment?.map((ele, index) => (
                              <STableRow key={`reimbursement-${index}`}>
                                <TableCell>
                                  <Typography variant="body2">
                                    {ele?.component_name || "-"}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2"></Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2"></Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {ele?.total?.toFixed(0) || "0"}
                                  </Typography>
                                </TableCell>
                              </STableRow>
                            ))} */}

                            {/* <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Total Reimbursement (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                </Typography>
                              </TableCell>
                              <TableCell />
                              <TableCell />
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {payslipData?.user_details?.reimbursment?.reduce(
                                    (sum, item) => sum + (item?.total || 0),
                                    0
                                  )?.toFixed(0) || "0"}
                                </Typography>
                              </TableCell>
                            </STableRow> */}

                            {/* Net Salary */}
                            <STableRow>
                              <TableCell>
                                <Typography variant="body2">
                                  <b>Net Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                </Typography>
                              </TableCell>
                              <TableCell />
                              <TableCell />
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {(payslipData?.user_details?.net_pay?.toFixed(2)) || "0.00"}
                                </Typography>
                              </TableCell>
                            </STableRow>
                          </Table>

                          {/* Footer */}
                          <div style={{ textAlign: "center", background: '#fff0cc' }}>
                            <i>
                              <b>
                                Total Net Payable ₹
                                {Math.round(payslipData?.user_details?.net_pay) || "0"} (
                                {numberToWords(payslipData?.user_details?.net_pay || 0)})
                              </b>
                            </i>
                            <p>
                              **Total Net Payable = Gross Earnings - Total
                              Deductions + Total Reimbursements
                            </p>

                            <i>
                              <p>
                                **This is a computer generated Payslip, doesn't
                                require signature of the competent Authority**
                              </p>
                            </i>
                          </div>
                          <br />
                        </TableContainer>
                      </Box>
                    </Box>
                  </Box>
                  {/* *******************New******************** */}

                </Box>
              </Grid>

              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    color: "#000000",
                    backgroundColor: "rgba(255, 255, 255, 0.20)",
                  }}
                >
                  <Toolbar />
                  <a>
                    <Box
                      sx={{
                        width: "90%",
                        background: "#FFFFFF",
                        ml: "auto",
                        mr: "auto",
                        mt: 2,
                        mb: 2,
                        p: 2,
                        borderRadius: "4px",
                        boxShadow: 1,
                        "&:hover": {
                          boxShadow: 6,
                        },
                      }}
                    >
                      <Typography variant="h6">Form 16</Typography>
                      <br />

                      <Typography variant="body2">
                        View/download your form 16.
                      </Typography>
                    </Box>
                  </a>
                </Box>
              </Grid>
            </>
          )}
        </Grid>

        {(userData && showManual) &&
          <>
            <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", ml: "auto", mr: "auto", p: 1, width: '100%' }}      >
              <button className="btn btn-success btn-block "
                style={{ padding: "4px 6px", fontSize: "15px", background: " #3298DB", border: "none", color: "white", borderRadius: "20px", }} classname="edit-icon" onClick={() => setUserData(null)}  >
                <ArrowBack />
              </button>

              <SButton onClick={manualpaylsipPrint}> <Typography variant="body2" sx={{ color: "#FFFFFF" }}>   Download </Typography>
              </SButton>
            </Box>
            <Box ref={manualInputRef}>
              {sessionStorage.getItem("coid") === "LSD 174449" ?
                <PaySlipHappycom userData={userData} />
                :
                <ViewPaySlip userData={userData} />
              }
            </Box>
          </>
        }
      </div>
    </div>
  );
};

export default Payslip;
